import React from "react";
import Select from "react-select";
import { Button } from "@mui/material";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import {
  useGetPatientDetailsByIdQuery,
  useGetPatientDetailsQuery,
} from "../../../../Service/appoinment";
import CustomInputs from "../../../../Component/DigitalMarketing/CustomInputs";
import useHandleChangeHooks from "../../../../hooks/digitalMarketing/useHandleChangeHooks";
import {
  useCreateAssignmentHistoryMutation,
  useGetAssignmentHistoryQuery,
  useGetCarePackageListsByIdQuery,
  useGetCarePackageListsQuery,
  useGetCarePackagesQuery,
} from "../../../../Service/CarePackages";
import BackdropLoader from "../../../../Component/DigitalMarketing/BackDropLoader";

const AssignPatient = (props) => {
  const { updateData, setShow } = props;
  const { open, message, openSnackBar, type } = useSnackbar();
  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});
    const [addAssignmentHistory, { isLoading: addLoading }] =
    useCreateAssignmentHistoryMutation();
  const { data: patientData } = useGetPatientDetailsQuery<any>({
    refetchOnMountOrArgChange: true,
  });
  const { data: carePackageData } = useGetCarePackageListsQuery<any>({
    refetchOnMountOrArgChange: true,
  });

  const { data: patient } = useGetPatientDetailsByIdQuery<any>(
    formData.patientId,
    {
      refetchOnMountOrArgChange: true,
      skip: !formData.patientId,
    }
  );
  console.log(updateData,'updateData')
  const pagi = {
    pageNo: 1,
    name:""
  };
  const {refetch } =
  useGetAssignmentHistoryQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });


  const { data: carePackage } = useGetCarePackageListsByIdQuery<any>(
    formData.carePackageId,
    {
      refetchOnMountOrArgChange: true,
      skip: !formData.carePackageId,
    }
  );

  console.log(carePackage,"carePackage");

  const handleSubmit = async () => {
    setSubmit(true);
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => !value
    );
    if (missingFields.length > 0) {
      openSnackBar("Fill required data", "error");
      return;
    }

    if (updateData?.id) {
      setTimeout(() => {
        openSnackBar("Updated successfully");
        setShow(false);
      }, 350);
    } else {
      await addAssignmentHistory(formData)
      refetch();
      setTimeout(() => {
        openSnackBar("Created successfully");
        setShow(false);
      }, 350);
    }

  
  };

  const patientOptions =
    patientData?.map((b: any) => ({
      label: b?.name,
      value: b?.customerId,
    })) || [];

  const carepackagesOptions =
    carePackageData?.map((b: any) => ({
      label: b?.packageName,
      value: b?.id,
    })) || [];

  return (
    <div>
      <BackdropLoader loader={addLoading}/>
      <Toast open={open} type={type} message={message} />
      <div className="mt-3">
        <span className="f-18 fw-700">
          {updateData.id ? "Edit Care Package" : "Assign Care Package"}
        </span>
      </div>

      {/* Patient Name Dropdown */}
      <div className=" row d-flex justify-content-between mt-2">
        <div className="col-sm-6">
          <label className="det-label">Patient Name</label>
        </div>
        <div className="input-custom col-sm-6">
          <CustomInputs
            type="select"
            option={patientOptions}
            labelKey="label"
            valueKey="value"
            validation="required"
            submit={submit}
            {...formData}
            onChange={handleChange}
            name="patientId"
            setFormData={setFormData}
          />
        </div>
      </div>

      {formData.patientId && (
        <div className="row d-flex justify-content-between mt-2">
          <div className="col-sm-6">
            <label className="det-label">Case ID</label>
          </div>
          <div className="input-custom col-sm-6">
            {Array.isArray(patient) && (
              <CustomInputs
                type="normal"
                submit={submit}
                value={patient[0]?.caseId}
                disabled={true}
                name="caseId"
              />
            )}
          </div>
        </div>
      )}
      
      {/* Care Package Dropdown */}
      <div className="row d-flex justify-content-between mt-2">
        <div className="col-sm-6">
          <label className="det-label">Care Package</label>
        </div>
        <div className="input-custom col-sm-6">
          <CustomInputs
            type="select"
            option={carepackagesOptions}
            labelKey="label"
            valueKey="value"
            validation="required"
            submit={submit}
            {...formData}
            onChange={handleChange}
            name="carePackageId"
            setFormData={setFormData}
          />
        </div>
      </div>

      

      {/* Validity */}
      {formData.carePackageId  && (
        <div className="row d-flex justify-content-between mt-2">
          <div className="col-sm-6">
            <label className="det-label">Validity</label>
          </div>
          <div className="input-custom col-sm-6">
            {Array.isArray(carePackage) && (
              <CustomInputs
                type="normal"
                submit={submit}
                value={carePackage[0]?.validityPeriod}
                disabled={true}
                name="validityPeriod"
              />
            )}
          </div>
        </div>
      )}

      {/* Submit Button */}
      <div
        className="d-flex justify-content-center mt-4"
        onClick={handleSubmit}
      >
        <Button variant="contained" id="btn-save">
          {updateData.id ? "Update Assign Package" : "Assign Package"}
        </Button>
      </div>
    </div>
  );
};

export default AssignPatient;
